



import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { Router } from '@angular/router';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { phoneNumberValidator } from 'src/app/shared/validators/phone-number.validator';
import { parseNaira } from 'src/app/shared/utils/convertToNumber';

@Component({
  selector: 'app-igr-assessment-application-modal',
  standalone: false,
  templateUrl: './additional-igr-assessment-modal.component.html',
  styleUrl: './additional-igr-assessment-modal.component.scss'
})
export class AdditionalIgrAssessmentModalComponent {
  form: FormGroup;
  isDarkMode!: boolean;

  details: any;
  isInAdditionalAssessmentMode!: boolean;

  isLoadingPrivileges: boolean = true;

  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;
  isLoading: boolean;

  showErrorMessages: boolean = false;

  itemList: any[];
  isListUpdated = false;


  vehicleTypes: any[] = [];

  rememberMe: boolean;





  categories = [];
  profilingTypes: any[];


  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AdditionalIgrAssessmentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.initForm();

    this.getAllVehicleTypes();

    this.form.get('vehicleTypeId')?.valueChanges.subscribe((id) => {
      const vehicle = this.vehicleTypes.find((v) => v.id === id);
      this.form.patchValue({ vehicleTypeName: vehicle ? vehicle.name : '' });
    });

    this.rememberMe = false;

    this.isInAdditionalAssessmentMode = this.dialogData.isInAdditionalAssessmentMode;


    if (this.dialogData?.id) {
      this.fetchDetails()
    }

    this.fetchProfilingTypes()
  }

  subscribeToprofilingTypeControl() {
    this.form.valueChanges.subscribe((category: any) => {
      if (category) {
        this.fetchCategories(category);
      }
    })
  }

  fetchProfilingTypes() {

    this.apiService
      .get(`/utility/profiling-type`)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {

        this.profilingTypes = response.map(item => ({ ...item, disabled: false }));

      });
  }


  initForm(): void {
    this.form = this.fb.group({
      category: [null, [Validators.required]],
      subCategory: [null, [Validators.required]],
    });



  }

  subCategories: any[];

  get categoryControl(): FormControl {
    return this.form.get('category')! as FormControl
  }



  fetchCategories(profilingTypeId: number) {
    this.categories = null;
    this.categoryControl.reset()
    this.apiService
      .get(`/utility/profiling-category?profilingTypeId=${profilingTypeId}`)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {

        this.categories = response;
      });
  }


  

  isCategorySelected(categoryId: number): boolean {
    return this.itemList.some(item => item.category?.categoryId === categoryId);
  }

  isSubCategorySelected(subCategoryId: number): boolean {
    return this.itemList.some(item => item.subCategory?.id === subCategoryId);
  }


  markAlreadyPaidAssessmentDetils
  fetchDetails() {
    this.details = this.dialogData
    this.mapFormValues(this.dialogData)

    this.apiService
      .get(`/assessment/details/${this.dialogData?.id}`)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.details = response.data;

        this.itemList = response?.data?.assessmentDetails?.map((item: any) => ({
          category: {
            id: item.profilingCategoryId,
            amount: item.regAmount,
            taxPayable: null,
            revenueDescription: item.profilingCategory,
          },
          profilingType: {
            category: item.profilingType,
            id: item.profilingTypeId
          },
          paid: true
        }))


        this.mapFormValues(response?.data)
      });
  }

  mapFormValues(data: any) {
    this.form.patchValue({
      phoneNumber: data?.phoneNumber,
      address: data?.address
    })
  }

  getAllVehicleTypes() {
    this.isLoading = true;
    this.apiService
      .get('/vehicle-type/all')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.vehicleTypes = response.data.map((vehicleType) => ({
          ...vehicleType,
          formattedName: this.toTitleCase(vehicleType.name.replace(/_/g, ' ')),
        }));
      });
  }

  toTitleCase(str: string): string {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }

  


  closeModal(): void {
    if (!this.isSubmitting) {
      this.dialogRef.close();
    }
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef.close({reload: true});
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  openConfirmModal() {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Are you sure you want to create an additional assessment for this user?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.submit();

        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }


  

  updateList() {
    this.isListUpdated = true;
  }

  addItemToList(): void {
    const formValues = this.form.value;



    if (this.form.valid) {
      const category = this.categories.find((item: any) => item.categoryId == formValues?.category);
      const subCategory = this.subCategories.find((item: any) => item.id == formValues?.subCategory);

  

      this.itemList.push({ category, subCategory });
      this.updateList()
      this.form.reset();
      this.showErrorMessages = false

    } else {
      this.showErrorMessages = true
    }
  }

  removeItem(index: number): void {
    this.itemList.splice(index, 1);
    this.updateList()

  }

  

  submit(): void {
    this.isSubmitting = true;
    this.form.disable();

    const formValues = this.form?.value;

    const request = {
      asin: this.details?.asin,
      assessmentYear: this.dialogData?.assessmentYear,
      requests: this.itemList
      .filter(item => parseNaira(item.category.taxPayable) > 0) // Keep only those with taxPayable
      .map(item => ({
        amount: parseNaira(item.category.taxPayable),
        profilingCategory: item.category.id,
        profilingType: item.profilingType.id
      }))      
    };

    this.apiService
      .post(`/assessment/additional-assessment/` + this.details.id, request)
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
          this.form.enable()
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal(response?.message);

        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );

    this.isSubmitAttempted = true;
  }
}
